import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const ArrowDownRightOutlinedSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 1H2.4L2.4 2.66683C2.4 4.57224 2.40149 5.93087 2.54021 6.96264C2.67622 7.97428 2.9325 8.56623 3.36655 9.00028C3.8006 9.43433 4.39255 9.69061 5.40419 9.82662C6.43596 9.96534 7.79459 9.96683 9.7 9.96683H12.3201L9.67688 7.32361L10.6668 6.33366L15 10.6668L10.6668 15L9.67688 14.0101L12.3201 11.3668H9.64704C7.80633 11.3668 6.35351 11.3669 5.21764 11.2141C4.05076 11.0573 3.11412 10.7278 2.3766 9.99023C1.63907 9.25271 1.30957 8.31607 1.15269 7.14919C0.999975 6.01332 0.999986 4.56049 1 2.71978L1 1Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const ArrowDownRightOutlinedSize16 = hoc(forwardRef(ArrowDownRightOutlinedSize16Component), 'ArrowDownRightOutlinedSize16');

export { ArrowDownRightOutlinedSize16 as default };
//# sourceMappingURL=ArrowDownRightOutlinedSize16.js.map
